import { createSlice } from '@reduxjs/toolkit';
import preventScroll from 'src/shared/utils/htmlScrollBlock';

import { RootState } from 'src/store';

// # types
interface PreventScrollState {
  count: number;
}

// # initial state
const initialState: PreventScrollState = {
  count: 0,
};

// # slice
const preventScrollSlice = createSlice({
  name: 'preventScroll',
  initialState,
  reducers: {
    startPreventScroll(state) {
      state.count++;
      if (state.count > 0) {
        preventScroll(true);
      } else {
        preventScroll(false);
      }
    },
    stopPreventScroll(state) {
      state.count = Math.max(state.count - 1, 0);
      if (state.count > 0) {
        preventScroll(true);
      } else {
        preventScroll(false);
      }
    },
    resetPreventScroll(state) {
      state.count = 0;
      preventScroll(false);
    },
  },
});

// # actions
export const { startPreventScroll, stopPreventScroll, resetPreventScroll } =
  preventScrollSlice.actions;

// # selectors
export const selectPreventScrollState = (state: RootState): boolean => {
  return state.preventScroll.count > 0;
};

export default preventScrollSlice.reducer;
